// alternative-dashboard\alternative-components\compactWidgetsCardDetails\SummaryCard.tsx
import { type SummaryCardItem } from "../../types/summaryCards";
import "../approval/styles/ApprovalRequiredPanel.scss";

interface SummaryCardProps {
  item: SummaryCardItem;
}

const toneClass = (tone?: string) => {
  switch (tone) {
    case "positive":
      return "alter-approval-policy-text_green";
    case "negative":
      return "alter-approval-policy-text_red";
    default:
      return "alter-approval-policy-text";
  }
};

const SummaryCard = ({ item }: SummaryCardProps) => {
  const isLabelVariant = item.titleVariant === "label";

  const trendContent = item.trend && (
    <p className={`${toneClass(item.trend.tone)} gx-p14-b`}>
      <span
        className={
          item.trend.direction === "up"
            ? "gx-summary-card__trend-icon gx-summary-card__trend-icon--up"
            : "gx-summary-card__trend-icon gx-summary-card__trend-icon--down"
        }
      >
        {item.trend.direction === "up" ? "▲" : "▼"}
      </span>{" "}
      {item.trend.label}
    </p>
  );

  return (
    <div
      className={`gx-alter-card ${
        item.variant === "primary" ? "gx-alter-card--primary" : ""
      }`}
      style={{
        ...(item.background && { background: item.background }),
        ...(item.color && { color: item.color }),
      }}
    >
      <h3
        className={`gx-alter-approval-header-text gx-p16-sb ${
          isLabelVariant ? " gx-alter-approval-header-text--label" : ""
        }`}
      >
        {item.title}
      </h3>

      <div className="gx-alter-approval-currency">
        <p className="alter-approval-policy-currency gx-p18-sb">
          {item.currency}
        </p>
        <span
          className={`gx-alter-approval-text-value gx-36-sb ${toneClass(item.amountTone)}`}
        >
          {item.amountWhole}
        </span>
        {item.amountDecimal && (
          <span className="gx-alter-approval-text-value gx-text-gray gx-36-sb">
            {item.amountDecimal}
          </span>
        )}
      </div>

      {trendContent}

      {!item.trend && item.lastUpdated && (
        <p className="gx-p10-r whitespace-nowrap">{item.lastUpdated}</p>
      )}

      {!item.trend && item.captionText && (
        <p className={`${toneClass(item.captionTone)} gx-p14-b`}>
          {item.captionText}
        </p>
      )}
    </div>
  );
};

export default SummaryCard;
